import { wrapReducer } from "@client/content/lib/helper";
import { type FailureActionData } from "@client/lib/actions";
import { type ReduxAction } from "@client/types/ReduxAction";
import { uuid } from "@common/lib/misc";
import {
  Actions,
  type CreateUpdateAccountSuccessActionData,
  type InitSuccessActionData,
  type OnTransferredActionData,
  type SetModalVisibleActionData,
  type SetShowingAccountDetailIdActionData
} from "./actions";
import { type MemberWallet } from "./types";

const reducer = (state: MemberWallet.AppState = defaultState, action: ReduxAction<any>): MemberWallet.AppState => {
  switch (action.type) {
    case Actions.InitBegin: {
      return {
        ...state,
        status: "Loading"
      };
    }
    case Actions.InitFailure: {
      return {
        ...state,
        status: "Failed"
      };
    }
    case Actions.InitSuccess: {
      const data = action.data as InitSuccessActionData;
      return {
        ...state,
        ...data,
        status: "Ready"
      };
    }
    case Actions.UpdateAccountBegin: {
      return {
        ...state,
        error: null,
        status: "Updating"
      };
    }
    case Actions.CreateAccountBegin: {
      return {
        ...state,
        error: null,
        status: "Creating"
      };
    }
    case Actions.UpdateAccountFailure:
    case Actions.CreateAccountFailure: {
      const { error } = action.data as FailureActionData;
      return {
        ...state,
        error,
        status: "Failed"
      };
    }
    case Actions.UpdateAccountSuccess:
    case Actions.CreateAccountSuccess: {
      const { accounts } = action.data as CreateUpdateAccountSuccessActionData;
      return {
        ...state,
        accounts,
        status: "Ready"
      };
    }

    case Actions.OnTransferred: {
      const { accounts } = action.data as OnTransferredActionData;
      return {
        ...state,
        accounts,
        refreshKey: uuid(),
        status: "Ready"
      };
    }

    case Actions.SetShowingAccountDetailId: {
      const { accountId } = action.data as SetShowingAccountDetailIdActionData;
      return {
        ...state,
        showingAccountDetailId: accountId,
        refreshKey: uuid()
      };
    }

    case Actions.SetAddEditAccountModalVisible: {
      const { isVisible } = action.data as SetModalVisibleActionData;
      return {
        ...state,
        isAddEditAccountModalVisible: isVisible
      };
    }

    case Actions.SetTransferModalVisible: {
      const { isVisible } = action.data as SetModalVisibleActionData;
      return {
        ...state,
        isTransferModalVisible: isVisible
      };
    }

    default:
      return state;
  }
};

export const defaultState: MemberWallet.AppState = {
  accounts: [],
  currencies: [],
  error: null,
  id: "",
  isAddEditAccountModalVisible: false,
  isTransferModalVisible: false,
  refreshKey: "",
  showingAccountDetailId: null,
  status: "None"
};
export const previewState: MemberWallet.AppState = {
  ...defaultState,
  accounts: [
    {
      accountId: "",
      accountNumber: "1111",
      balance: 100,
      closingBalance: 100,
      convertBalanceCurrencyCode: "USD",
      convertedBalance: 100,
      createdOnDate: new Date().toISOString(),
      currencyCode: "USD",
      currencyName: "USD",
      firstName: "Dummy",
      isPreferred: true,
      lastName: "Dummy",
      minTransferAmount: 10,
      openingBalance: 100,
      userId: 100
    }
  ],
  currencies: [{ currencyCode: "USD", isCommission: true, label: "USD" }],
  status: "Ready"
};
export default wrapReducer({ defaultState, reducer, previewState });
